import React from 'react';
import { observer } from 'mobx-react-lite';
import { FixedSizeList } from 'react-window';
import SearchResultContact from '../SearchResultContact/SearchResultContact';
import { useRootStore } from '../../../../mobx/bridge';

// eslint-disable-next-line prefer-arrow-callback,sonarjs/cognitive-complexity
const SearchResultList = observer(function SearchResultList(props) {
  const { listHeight, collectionToShow, showAddCustomer } = props;
  const { commonStore } = useRootStore();
  const ref = React.useRef();

  React.useEffect(() => {
    if (ref?.current) {
      ref.current.scrollTo(0);
    }
  }, [commonStore.isSettingsMenuOpen]);

  const Item = ({ index, style }) => (
    <div style={style}>
      <SearchResultContact
        key={index}
        contact={collectionToShow[index]}
        showAddCustomer={showAddCustomer}
      />
    </div>
  );

  return (
    <FixedSizeList ref={ref} itemCount={collectionToShow.length} height={listHeight} itemSize={61}>
      {Item}
    </FixedSizeList>
  );
});
SearchResultList.whyDidYouRender = true;
SearchResultList.displayName = 'SearchResultList';

export default React.memo(SearchResultList);
